import VeeValidate from 'vee-validate'
import Vue from 'vue'

Vue.use(VeeValidate, {
  inject: false,
  events: 'blur'
})
